<!--
 * @Author: 月魂
 * @Date: 2021-01-27 15:17:31
 * @LastEditTime: 2022-01-26 15:21:22
 * @LastEditors: 月魂
 * @Description: 
 * @FilePath: \bingmayong-ukraine-mobile\src\views\History.vue
-->
<template>
  <div class="cont">
    <Header title="history" />
    <!-- 弹出视频 -->
    <van-overlay v-if="show" :show="show" @click="show = false">
      <div class="wrapper">
        <video
          src="http://image.wearetogether.com.cn/history-fir.mp4"
          poster="http://cdn.topartsintermational.com/history-video-bg-ser.jpg"
          controls
          width="100%"
          style="display: block"
          @click.stop="() => {}"
        ></video>
      </div>
    </van-overlay>
    <img src="http://image.wearetogether.com.cn/hisbg-ukraine.jpg" alt="" style="display:block; width: 100%">
    <!-- 正文内容 -->
    <h1 class="title">{{ setting.part1.title }}</h1>
    <div class="video">
      <video
        src="http://cdn.topartsintermational.com/history-show.mp4"
        poster="http://cdn.topartsintermational.com/history-show-bg.jpg"
        controls
        width="100%"
        x5-video-player-type="h5"
        playsinline="true"
        webkit-playsinline="true"
      ></video>
    </div>
    <p class="des">{{ setting.part1.des1 }}</p>
    <p class="des">{{ setting.part1.des2 }}</p>
    <div
      class="title"
      style="text-align: left; width: 350px; margin: 16px auto 0"
    >
      <div class="title" style="border-bottom: 2px solid #bc924f">
        {{ setting.part2.title }}
      </div>
    </div>
    <p class="des">{{ setting.part2.des1 }}</p>
    <div class="all">
      <img
        src="http://cdn.topartsintermational.com/his-img.png"
        width="350px"
        style="display: block; margin: auto"
      />
      <div class="all-des">
        <p>{{ setting.part2.des2 }}</p>
        <p>{{ setting.part2.des3 }}</p>
      </div>
    </div>
    <p class="des">{{ setting.part2.des4 }}</p>
    <p class="des">{{ setting.part2.des5 }}</p>
    <div class="dif">
      <div class="dif-cont">
        <div class="dif-title title">{{ setting.part3.title }}</div>
        <p class="dif-des">{{ setting.part3.des1 }}</p>
        <p class="dif-des">{{ setting.part3.des2 }}</p>
      </div>
    </div>
    <div class="ter">
      <div class="ter-left">
        <div class="ter-title title">{{ setting.part4.title }}</div>
        <p class="ter-des">{{ setting.part4.des }}</p>
      </div>
      <div class="ter-right">
        <img
          src="http://cdn.topartsintermational.com/ter-img1.png"
          width="120px"
        />
        <img
          src="http://cdn.topartsintermational.com/ter-img2.png"
          width="220px"
        />
      </div>
    </div>
    <img src="http://cdn.topartsintermational.com/hisLine.png" width="100%" />
    <div class="pho">
      <h1 class="title">{{ setting.photo }}</h1>
      <div class="wall">
        <img src="http://cdn.topartsintermational.com/1.jpg" />
        <img src="http://cdn.topartsintermational.com/2.jpg" />
        <img src="http://cdn.topartsintermational.com/3.jpg" />
        <img src="http://cdn.topartsintermational.com/4.jpg" />
        <img src="http://cdn.topartsintermational.com/5.jpg" />
        <img src="http://cdn.topartsintermational.com/7.jpg" />
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from '../components/Header'
import Footer from '../components/Footer'
export default {
  name: 'History',
  components: {
    Header,
    Footer
  },
  data () {
    return {
      show: true,
      setting: {
        // 第一部分
        part1: {
          title: this.$t('message.link.history'),
          des1: this.$t('message.history.part1.des1'),
          des2: this.$t('message.history.part1.des2'),
        },
        // 第二部分
        part2: {
          title: this.$t('message.history.part2.title'),
          des1: this.$t('message.history.part2.des1'),
          des2: this.$t('message.history.part2.des2'),
          des3: this.$t('message.history.part2.des3'),
          des4: this.$t('message.history.part2.des4'),
          des5: this.$t('message.history.part2.des5'),
        },
        // 第三部分
        part3: {
          title: this.$t('message.history.part3.title'),
          des1: this.$t('message.history.part3.des1'),
          des2: this.$t('message.history.part3.des2'),
        },
        // 第四部分
        part4: {
          title: this.$t('message.history.part4.title'),
          des: this.$t('message.history.part4.des'),
        },
        // 照片墙
        photo: this.$t('message.history.photo'),
      },
    }
  },
}
</script>

<style scoped lang="less">
.cont {
  // background: url("http://image.wearetogether.com.cn/hisbg-bg.jpg") repeat;
  // background-size: contain;
  box-sizing: border-box;
  background-color: #4e0e0f;
  // padding-top: 150px;
  .title {
    color: #fff;
    text-align: center;
    margin: 16px 0 0 0;
  }
  .video {
    width: 350px;
    margin: 16px auto;
  }
  .des {
    width: 350px;
    margin: 0 auto;
    color: #fff;
    text-indent: 2em;
    line-height: 1.8;
  }
  .all {
    width: 350px;
    margin: 16px auto 0;
    color: #fff;
  }
  .all-des {
    width: 350px;
    margin-top: 16px;
    text-indent: 2em;
    line-height: 1.8;
  }
  .dif {
    background-image: url("http://cdn.topartsintermational.com/his-img1.png");
    background-size: cover;
    background-repeat: no-repeat;
  }
  .dif-cont {
    width: 350px;
    padding: 16px 0;
    margin: 16px auto 0;
    color: #fff;
    text-indent: 2em;
    line-height: 1.8;
  }
  .dif-title {
    border-bottom: 2px solid #bc924f;
  }
  .ter {
    width: 350px;
    margin: auto;
    padding: 16px 0;
  }
  .ter-left {
    width: 350px;
    color: #fff;
  }
  .ter-title {
    border-bottom: 2px solid #bc924f;
    text-align: center;
  }
  .ter-des {
    margin-top: 8px;
    text-indent: 2em;
    line-height: 1.8;
  }
  .ter-right {
    width: 350px;
    display: flex;
    justify-content: space-between;
    margin-top: 16px;
  }
  .pho {
    width: 350px;
    margin: auto;
    padding: 16px 0;
  }
  .wall {
    display: flex;
    justify-content: space-between;
    margin-top: 16px;
    overflow: auto;
    img {
      width: 150px;
      height: 220px;
      margin-right: 8px;
    }
  }
}
</style>